import { Grid,Container } from '@mui/material';
import { Typography, useTheme } from '@mui/material';

function Projects() {
    const theme = useTheme();
    return(
        <Container sx={{ width: '100%', height: '100%' }} maxWidth="lg"> 
            <Grid container columns={{xs: 4, sm: 8, md: 12}} spacing={2} justifyContent='center' sx={{ marginBottom: '100px' }}>
                <Grid container xs={12} sx={{ width: '100%', height: '200px', display: 'flex', flexDirection: 'column' }}>
                    <Typography variant='h1' style={{ fontSize: theme.typography.title1.fontSize, marginTop: 'auto' }} textAlign='center'>
                        PROJECTS GALLERY
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={{ marginBottom: '100px' }}>
                    <Typography variant="body1" textAlign="center" style={{ 
                        fontSize: theme.typography.subtitle1.fontSize, 
                        fontFamily: theme.typography.subtitle1.fontFamily, 
                        fontWeight: theme.typography.subtitle1.fontWeightThin,
                        letterSpacing: '2px'
                    }}>
                        Find my interesting projects here
                    </Typography>
                </Grid>
                <Grid item xs={12} className='jumbotron'><h2>Coming Soon...</h2></Grid>
            </Grid>
        </Container>
    )
}

export default Projects